module.exports = __webpack_public_path__ + "img/img-pickup03.098412fd.jpg";